import { Action } from 'redux';

import { isGetExtractEncryptionKeyRequest, isGetExtractEncryptionKeyRequestSucceeded } from '../actions/GetExtractEncryptionKeyRequestAction';
import { isGetSiteSettingsRequest, isSiteSettingsRequestSucceeded } from '../actions/SiteSettingsRequestAction';
import { IExtractEncryptionInfo } from '../models/ExtractEncryptionModels';

const InitialState: IExtractEncryptionInfo = {
    encryptionKey: undefined,
    isFetchingEncryptionKey: false,
    siteSettings: undefined,
    isFetchingSiteSettings: false
};

export function extractEncryptionReducer(
  previousState: IExtractEncryptionInfo= InitialState,
  action: Action
): IExtractEncryptionInfo {
    if(isGetExtractEncryptionKeyRequest(action)){
        return {
            ...previousState,
            isFetchingEncryptionKey: true
        };
    }
    else if (isGetExtractEncryptionKeyRequestSucceeded(action)) {
        return {
            ...previousState,
            encryptionKey: (action as any)?.encryptionKey ?? undefined,
            isFetchingEncryptionKey: false
        };
    }
    else if (isGetSiteSettingsRequest(action)) {
        return {
            ...previousState,
            isFetchingSiteSettings: true
        };
    }
    else if (isSiteSettingsRequestSucceeded(action)) {
        return {
            ...previousState,
            siteSettings: (action as any)?.siteSettings ?? undefined,
            isFetchingSiteSettings: false
        };
    }
    return previousState;
}